module.exports = __webpack_public_path__ + "img/app_img1_1.1cdcedfe.png";